export default {
  BIO:   'bio',
  STYLE: 'style'
};
